import React from "react"
import Table from "../../common/Table"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, CircularProgress, FloatingActionButton } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import AddClientTypeDialog from "./AddClientTypeDialog"
import TableActionBar from "../../../components/layout/TableActionBar"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import * as api from "../../../api"
import { IClientType } from "../../../models"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
interface IProps {
}
interface IState {
	loading: boolean
	searchText: string
	clientTypes: IClientType[]
	selectedClientType: IClientType
	openAddClientTypeDialog: boolean
	editClientType: IClientType
}

export default class ClientTypes extends React.Component<IProps, IState>  {
	constructor(props) {
		super(props)
		this.state = {
			loading: true,
			searchText: "",
			clientTypes: [],
			selectedClientType: null,
			openAddClientTypeDialog: false,
			editClientType: null
		}
		autobind(this)
	}

	componentDidMount() {
		this.getClientTypes()
	}

	getClientTypes() {
		api.getClientTypes(AccountStore.getCurrentAccount().Id).then(res => {
			const clientTypes: IClientType[] = res.data
			AppStateStore.setProgressSnackbarContent(null)
			this.setState({
				loading: false,
				clientTypes: clientTypes.filter(i => i.Active && !i.Deleted),
				selectedClientType: null
			})
		})
	}

	render() {
		const searchedClientTypes = this.state.clientTypes.filter(i => i.Name.toLowerCase().includes(this.state.searchText.toLowerCase()) || i.Abbreviation.toLowerCase().includes(this.state.searchText.toLowerCase()))
		return (
			<div>
				<FloatingActionButton data-intercom-target={"menu-AccountSettings-ClientSetting-ClientTypeTab-Btn-Add"} className="fixed-add" style={{ top: -28, right: 20 }} secondary={true} onTouchTap={() => this.setState({ openAddClientTypeDialog: true })}>
					<ContentAdd />
				</FloatingActionButton>
				<div style={{ paddingTop: 30 }}>
					<TableActionBar
						onSearch={searchText => this.setState({ searchText, selectedClientType: null })}
						searchText={this.state.searchText}
						rowSelectionCount={this.state.selectedClientType ? 1 : 0}
						singleSelectedMessage={strings.Client_Type_Selected}
						title={strings.Client_Types}
						titleStyle={{ fontSize: 16 }}
						bodyStyle={{ padding: 20, fontWeight: 500 }}
						onDeleteClick={() =>
							AppStateStore.setConfirmDialogContent({
								content: strings.Are_you_sure_you_want_to_delete_the_selected_Client_Type,
								confirm: () => {
									AppStateStore.setProgressSnackbarContent("loading")
									api.deleteClientType(AccountStore.getCurrentAccount().Id, this.state.selectedClientType.Id)
										.then(() =>
											this.getClientTypes()
										)
										.catch(err =>
											AppStateStore.setProgressSnackbarContent(err.response.data.message)
										)
								}
							})
						}
					/>
					<div style={{ maxHeight: 250, overflowY: "auto" }}>
						{this.state.loading ?
							<div className="spinner">
								<CircularProgress />
							</div> :
							<div>
								{!searchedClientTypes.length ?
									<div>
										<h2 style={{ textAlign: "center", marginTop: 25 }}>
											{strings.No_client_type_found}
										</h2>
									</div> :
									<Table
										singleSelectable
										allowClickRow
										items={searchedClientTypes}
										selectedItems={this.state.selectedClientType ? [this.state.selectedClientType] : []}
										handleClickRow={editClientType => this.setState({ openAddClientTypeDialog: true, editClientType })}
										handleSelect={items => this.setState({ selectedClientType: items.length > 0 ? items[0] : null })}
									>
										<TableHeader>
											<TableRow>
												<TableHeaderColumn style={{ paddingLeft: 0, paddingRight: 0 }}>{strings.Type_Name}</TableHeaderColumn>
											</TableRow>
										</TableHeader>
										<TableBody deselectOnClickaway={false}>
											{searchedClientTypes.map((row, key) =>
												<TableRow selected={this.state.selectedClientType && this.state.selectedClientType.Id === row.Id} key={key}>
													<TableRowColumn style={{ paddingLeft: 0, paddingRight: 0 }}>{row.Name}</TableRowColumn>
												</TableRow>
											)}
										</TableBody>
									</Table>
								}
							</div>
						}
					</div>
				</div>
				{this.state.openAddClientTypeDialog &&
					<AddClientTypeDialog
						clientTypes={this.state.clientTypes}
						editClientType={this.state.editClientType}
						handleClose={() => this.setState({ openAddClientTypeDialog: false, editClientType: null })}
						handleAdd={clientType => {
							this.setState({ openAddClientTypeDialog: false, editClientType: null })
							AppStateStore.setProgressSnackbarContent("loading")
							api.addClientType(AccountStore.getCurrentAccount().Id, clientType).then(() =>
								this.getClientTypes()
							)
						}}
						handleUpdate={clientType => {
							this.setState({ openAddClientTypeDialog: false, editClientType: null })
							AppStateStore.setProgressSnackbarContent("loading")
							api.updateClientType(AccountStore.getCurrentAccount().Id, clientType).then(() =>
								this.getClientTypes()
							)
						}}
					/>
				}
			</div>
		)
	}
}
